import Video from "./video.container";

export default Video;
